const types = {
  analysts: {
    title: 'analysts',
    items: [
      {
        title: 'architect',
        shortTitle: 'intp',
        slug: 'intp',
        defaultGender: 'female',
        order: 2,
      },
      {
        title: 'commander',
        shortTitle: 'entj',
        slug: 'entj',
        defaultGender: 'other',
        order: 3,
      },
      {
        title: 'mastermind',
        shortTitle: 'intj',
        slug: 'intj',
        defaultGender: 'male',
        order: 1,
      },
      {
        title: 'visionary',
        shortTitle: 'entp',
        slug: 'entp',
        defaultGender: 'male',
        order: 4,
      },
    ],
  },
  diplomats: {
    title: 'diplomats',
    items: [
      {
        title: 'counselor',
        shortTitle: 'infj',
        slug: 'infj',
        defaultGender: 'male',
        order: 1,
      },
      {
        title: 'mediator',
        shortTitle: 'infp',
        slug: 'infp',
        defaultGender: 'female',
        order: 2,
      },
      {
        title: 'teacher',
        shortTitle: 'enfj',
        slug: 'enfj',
        defaultGender: 'female',
        order: 3,
      },
      {
        title: 'champion',
        shortTitle: 'enfp',
        slug: 'enfp',
        defaultGender: 'male',
        order: 4,
      },
    ],
  },
  sentinels: {
    title: 'sentinels',
    items: [
      {
        title: 'logistician',
        shortTitle: 'istj',
        slug: 'istj',
        defaultGender: 'male',
        order: 1,
      },
      {
        title: 'defender',
        shortTitle: 'isfj',
        slug: 'isfj',
        defaultGender: 'other',
        order: 2,
      },
      {
        title: 'executive',
        shortTitle: 'estj',
        slug: 'estj',
        defaultGender: 'female',
        order: 3,
      },
      {
        title: 'consul',
        shortTitle: 'esfj',
        slug: 'esfj',
        defaultGender: 'female',
        order: 4,
      },
    ],
  },
  explorers: {
    title: 'explorers',
    items: [
      {
        title: 'virtuoso',
        shortTitle: 'istp',
        slug: 'istp',
        defaultGender: 'male',
        order: 1,
      },
      {
        title: 'adventurer',
        shortTitle: 'isfp',
        slug: 'isfp',
        defaultGender: 'female',
        order: 2,
      },
      {
        title: 'entrepreneur',
        shortTitle: 'estp',
        slug: 'estp',
        defaultGender: 'other',
        order: 3,
      },
      {
        title: 'entertainer',
        shortTitle: 'esfp',
        slug: 'esfp',
        defaultGender: 'other',
        order: 4,
      },
    ],
  },
};

export const mapGroupToColor = {
  analysts: 'red',
  diplomats: 'mint',
  sentinels: 'blue',
  explorers: 'orange',
};

export const typesArray = Object.keys(types).reduce(
  (acc, groupType) => [
    ...acc,
    ...types[groupType].items.map((item) => ({ ...item, group: types[groupType] })),
  ],
  [],
);
const emptyType = {
  shortTitle: '', title: '', slug: '', group: {},
};

export function findBy(field, valueToFind) {
  if (!field || !valueToFind) {
    return emptyType;
  }
  return (
    typesArray.find((item) => item[field]?.toLowerCase?.() === valueToFind.toLowerCase())
    || emptyType
  );
}
export function findByType(type) {
  return findBy('slug', type);
}
export function colorByType(type) {
  return mapGroupToColor[findByType(type)?.group?.title] || false;
}

export default types;
